module.exports = __webpack_public_path__ + "img/1557614084467269635.7e515e0a.png";